// PorterIQ Custom Card Styles
import { GLASS_CARD, GRADIENTS } from "../../../../utils/designTokens";

export default {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      background: GLASS_CARD.background,
      backdropFilter: GLASS_CARD.backdropFilter,
      borderRadius: GLASS_CARD.borderRadius,
      position: "relative",
      color: "#fff",
      overflow: "visible",
      boxShadow: "none",
      padding: GLASS_CARD.padding,
      "&::before": {
        content: '""',
        position: "absolute",
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: GLASS_CARD.borderRadius,
        padding: "1.5px",
        background: GRADIENTS.cardBorder,
        WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        pointerEvents: "none",
      },
    },
  },
};
